const initialState = {};

const reductions = {
  ADD_TYPING_STATUS: (state, action) => {
    const currentUsers = state[action.payload.conversation_id] || [];
    let found = false;
    const newCurrentUsers = currentUsers.map((user) => {
      if (Number(user.id) === Number(action.payload.user.id)) {
        found = true;
        return action.payload.user;
      }
      return user;
    });
    if (!found) {
      newCurrentUsers.push(action.payload.user);
    }
    return Object.assign({}, state, {
      [action.payload.conversation_id]: newCurrentUsers,
    });
  },
  REMOVE_TYPING_STATUS: (state, action) => {
    const currentUsers = state[action.payload.conversation_id] || [];
    const newCurrentUsers = currentUsers.filter(
      (u) => Number(u.id) !== Number(action.payload.user.id)
    );
    return Object.assign({}, state, {
      [action.payload.conversation_id]: newCurrentUsers,
    });
  },
};

const typingStatusReducer = (state = initialState, action) => {
  if (action && action.type && reductions[action.type]) {
    return reductions[action.type](state, action);
  }
  return state;
};

export default typingStatusReducer;
